import { pushTo } from '@app/core/routing';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { useComposition } from '@app/modules/compose/screens/view/hooks/useComposition';
import { isSamePlatformId } from '@app/modules/social-export/domain/is-same-platform-id';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { PublishPlatformBar } from '@app/modules/social-export/publish';
import { useCompositionPublishableRenderedEdits } from './useCompositionPublishableRenderedEdits';

/**
 * Platform icon bar for compositions; navigates to the composition upload wizard per platform.
 */
export function ComposeSocialExportPublishDropdown() {
  const { composition } = useComposition();
  const stationId = composition.stationId ?? undefined;
  const { platforms: availablePlatforms } = useAvailableSocialExportPlatformsForStation(stationId);
  const { hasAvailableSources } = useCompositionPublishableRenderedEdits(composition.id);

  const handlePlatformSelect = (platformId: string) => {
    const platform = availablePlatforms.find((p) => isSamePlatformId(p.id, platformId));
    if (platform) {
      pushTo(composeRouteGenerator.upload(composition.id, platform.id));
    }
  };

  return (
    <PublishPlatformBar
      platforms={availablePlatforms}
      disabled={!hasAvailableSources}
      onSelectPlatform={handlePlatformSelect}
    />
  );
}
